"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DialogHandler = {
  dialogsArray: [],
  currentDialog: null,
  register: function register(dialog) {
    this.currentDialog = dialog;
  },
  unregister: function unregister() {
    this.currentDialog = null;
  },
  isShowing: function isShowing() {
    return this.currentDialog.isShowing();
  },
  queued: function queued() {
    return this.dialogsArray.length;
  },
  clearQueue: function clearQueue() {
    this.dialogsArray = [];
  },
  startAnimation: function startAnimation() {
    this.currentDialog.startAnimation();
  },
  stopAnimation: function stopAnimation() {
    this.currentDialog.stopAnimation();
  },
  resetAnimation: function resetAnimation() {
    this.currentDialog.resetAnimation();
  },
  show: function show() {
    var _this = this;
    var newState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (this.currentDialog === null) {
      return;
    }
    setTimeout(function () {
      if (_this.isShowing()) {
        if (!newState.hasOwnProperty("isExpress") || newState.hasOwnProperty("isExpress") && !newState.isExpress) {
          if (newState.hasOwnProperty("isPriority") && newState.isPriority) {
            _this.dialogsArray.unshift(newState);
          } else {
            _this.dialogsArray.push(newState);
          }
          return;
        }
      }
      if (newState !== null) {
        _this.currentDialog.show(newState);
      } else {
        _this.currentDialog.show();
      }
    }, 0);
  },
  hide: function hide() {
    var _this2 = this;
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    if (this.currentDialog === null) {
      return;
    }
    setTimeout(function () {
      _this2.currentDialog.hide(callback);
      if (_this2.dialogsArray.length > 0) {
        _this2.show(_this2.dialogsArray[0]);
        _this2.dialogsArray.shift();
      }
    }, 0);
  }
};
var _default = exports["default"] = DialogHandler;